import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TitleService } from '../../services/title/title.service';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  currentHeadlineBase = 'Loading...';
  currentHeadLineExtension = 'Loading...';

  titleService: TitleService;
  title: Title;
  constructor(
    private router: Router,
    titleService: TitleService,
    title: Title,
  ) {
    this.titleService = titleService;
    this.title = title;

    this.updateHeader();
  }

  updateHeader() {
    this.titleService.getTitleExtension(this.router.url, (titleExtension) => {
      this.currentHeadLineExtension = titleExtension;
      this.titleService.getTitleBase((titleBase) => {
        this.currentHeadlineBase = titleBase;
        this.title.setTitle(titleBase + ' - ' + titleExtension);
      });
    });
  }
}
